import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import { api, formatApiError } from "../lib/api";

export default function Journal() {
  const [items, setItems] = useState([]);
  const [err, setErr] = useState(null);
  useEffect(() => {
    api.get("/articles").then(({ data }) => setItems(data)).catch((e) => setErr(formatApiError(e)));
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAFA]" data-testid="journal-page">
      <Helmet>
        <title>The Journal — Abril Suarez Makeup Artist</title>
        <meta name="description" content="Ensayos sobre maquillaje, piel y método por Abril Suarez." />
      </Helmet>
      <Header />

      <section className="px-6 sm:px-10 pt-32 pb-16 max-w-4xl mx-auto">
        <p className="overline text-[#8B6D5E] mb-4">— The Journal</p>
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1.02] mb-6">
          Ensayos sobre lo que <em className="text-[#8B6D5E]">no se ve</em>.
        </h1>
        <p className="text-lg leading-relaxed text-[#3D3D3D] max-w-2xl">
          Piezas sobre maquillaje, piel y método — por Abril Suarez.
          Textos largos, con calma, para leer antes de tu cita.
        </p>
      </section>

      <div className="border-t border-[#E8E1DA]" />

      <section className="px-6 sm:px-10 py-8 max-w-4xl mx-auto">
        {err && <p className="text-sm text-[#9E3C3C] py-6">{err}</p>}
        {items.map((a, i) => (
          <Link
            key={a.slug}
            to={`/journal/${a.slug}`}
            className="grid md:grid-cols-[1fr_2fr] gap-8 md:gap-12 py-12 border-b border-[#E8E1DA] group"
            data-testid={`journal-item-${i}`}
          >
            <div>
              <p className="overline text-[#8B6D5E] mb-3">
                {a.category} · {new Date(a.published_at).toLocaleDateString("es-MX", { day: "numeric", month: "long", year: "numeric" })}
              </p>
              {a.cover_image && (
                <img src={a.cover_image} alt={a.title} className="w-full aspect-[4/5] object-cover" loading="lazy" />
              )}
            </div>
            <div>
              <h2 className="font-serif text-3xl sm:text-4xl mb-4 leading-tight group-hover:text-[#8B6D5E] transition-colors">{a.title}</h2>
              <p className="text-base leading-relaxed text-[#3D3D3D] mb-4">{a.excerpt}</p>
              <p className="overline text-[#8B6D5E] flex items-center gap-2">
                Leer {a.reading_time} min <span className="transition-transform group-hover:translate-x-1">→</span>
              </p>
            </div>
          </Link>
        ))}
        {items.length === 0 && !err && <p className="text-sm text-[#5C5C5C] py-12 text-center">Cargando...</p>}
      </section>

      <Footer />
    </div>
  );
}
